import React from "react";

function ExternalNavbarButtons() {
  return (
    <div className="flex h-[54px] flex-1 items-center justify-end self-center ">
      <div className="flex items-center justify-center gap-[14px] ">
        <a
          href="https://www.instagram.com/procompsgg/"
          target="_blank"
          className=" flex h-9 w-9 max-w-full items-center justify-center rounded-full bg-[#f4f4f4] transition-all duration-200 hover:-translate-y-1 hover:bg-[#12ac95]"
          rel="noreferrer"
        >
          <img src="images/6239ba03ad9611637a539ec3_Instagram.svg" loading="lazy" alt="" />
        </a>
        <a
          id="w-node-c406dc4c-9423-8050-7476-bfb55f7a8321-5f7a831e"
          href="https://twitter.com/procompsgg"
          target="_blank"
          className=" flex h-9 w-9 max-w-full items-center justify-center rounded-full bg-[#f4f4f4] transition-all duration-200 hover:-translate-y-1 hover:bg-[#12ac95]"
          rel="noreferrer"
        >
          <img src="images/6239ba027a3bbd1ec055fda8_Twitter.svg" loading="lazy" alt="" />
        </a>
        <a
          href="https://discord.com/invite/3BTGqnpQyf"
          target="_blank"
          className=" flex h-9 w-auto max-w-full items-center justify-center gap-1 rounded-[200px] bg-[#f4f4f4] px-2 py-2 transition-all duration-200 hover:-translate-y-1 hover:bg-[#12ac95]"
          rel="noreferrer"
        >
          <img src="images/discord-alt-svgrepo-com.svg" loading="lazy" alt="" />
          <p className="font-unbounded text-[12px] font-medium  uppercase text-[#272727]">
            +7K Members
          </p>
        </a>
      </div>
    </div>
  );
}

export default ExternalNavbarButtons;
